import React from "react"
import {
  AnchorLink as GatsbyAnchorLink,
  AnchorLinkProps,
} from "gatsby-plugin-anchor-links"

interface AnchorLink extends AnchorLinkProps {}

export const AnchorLink = ({ children, ...rest }: AnchorLinkProps) => {
  return <GatsbyAnchorLink {...rest}>{children}</GatsbyAnchorLink>
}
